/*
 * @Description: In User Settings Edit
 * @Author: Songsong_yu
 * @Date: 2020-02-24 16:24:27
 * @LastEditTime: 2020-04-30 14:39:10
 * @LastEditors: Songsong_yu
 */
/**
 * 表单中间件
 * */

import { mapGetters } from 'vuex'
import { platformMap } from '@/config'

export default {
    data() {
        return {
            mgType: 0, // 平台标示 0：物联网平台,  1：车载设备平台,  2: 应用中心   3: 项目管理系统
        }
    },
    computed: {
        loginText() {
            return this.language === 'zh' ? '已有账户? ' : 'Already have an account, please '
        },
        loginBtnText() {
            return this.language === 'zh' ? '快速登录' : 'Sign in'
        },
        registerUrl() {
            // myType对用的url，区分测试正式环境
            let registerUrl = platformMap.find(item => item.key === this.mgType).url
            return registerUrl
        },
        ...mapGetters(['language', 'size']),
    },
    created() {
        this.mgType = this.$route.query.mgType
        if (this.mgType) {
            this.mgType = Number(this.mgType)
        } else {
            this.mgType = 0
        }
    },
    methods: {
        toLogin() {
            platformMap.map(item => {
                if (item.key === this.mgType) {
                    window.location.href = item.url
                }
            })
        },
    },
}
